import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Stack} from "@mui/material";
import {
   DownloadOutlined,
   SpeakerNotesOutlined,
} from "@mui/icons-material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { DownloadFile } from "./quotaModificationSlice";

export default function Comments() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quotaModification);

   const {
      scenarioModificationList, selectedModificationNumber
   } = state;  
   if (scenarioModificationList === null) {
      return null;
   }
   const handleDownloadFile = (filepath) =>{
      dispatch(DownloadFile(filepath));
   }
   let modification =[];
   if(selectedModificationNumber !== undefined && selectedModificationNumber !== ""){
      modification = scenarioModificationList.find(x=> x.modificationNo === selectedModificationNumber);
   }else{
      modification = scenarioModificationList[0];
   }
   const {comments, listQuotaFiles} = modification;
   return (
      scenarioModificationList && (
      <Box sx={{ mt: 2 }}>
         {listQuotaFiles?.length > 0 && (
                     <Typography  sx={{ color: "#007DC3", fontWeight: "bold", width:" 100%",}}>
                     <AttachFileIcon  color="info" sx={{transform:" translate(0px, 6px)", width: 18,}} />
                        Attachments
                     </Typography>
               )}
               <Table>
                  <TableBody>
                     {listQuotaFiles?.map((row) => {
                        return (
                           <TableRow className="tableRow" key={row?._id}>
                              <TableCell
                                 className="tableCell"
                                 sx={{ flexGrow: 1, }}
                              >
                                 {row.filePath}
                              </TableCell>
                              <TableCell className="tableCell">
                                 <Button
                                    variant="outlined"
                                    startIcon={<DownloadOutlined />}
                                    size="small"
                                    onClick={() => handleDownloadFile(row.filePath)}
                                 >
                                    Download
                                 </Button>{" "}
                              </TableCell>
                           </TableRow>
                        );
                     })}
                  </TableBody>
               </Table>
         <div>
            <Stack direction="row" alignItems="center" gap={2} sx={{mt:3,}}>
                  <Typography sx={{ color: "#007DC3", fontWeight: "bold", width:"100%" }}>
                  <SpeakerNotesOutlined sx={{transform:" translate(0px, 6px)", width: 20,mr: 1,}}  color="info" />
                     Comments
               </Typography>
            </Stack>
         </div>

         <div>
            <TextField
               className={'fullWidth'}
               size="large"
               multiline
               rows= {6}
               value ={comments}
               style={{overflowY:'auto'}}
               disabled
               //inputProps={{ style: { width: 400 } }}
            />
         </div>
         {/* <div>
            <Button
               sx={{
                  width: 40,
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
            >
               View
            </Button>
         </div> */}
      </Box>
      )
   );
}
